// DS: MO3.4.3
import React from 'react';
import DeviationShopCard from '../DeviationShopCard';
import AdoptableCardStats from './_partials/AdoptableCardStats';
import AdoptableDetailsRightSide from './_partials/AdoptableDetailsRightSide';
const AdoptableShopCard = ({ width, deviation, withAuthorDetails, withIndicators, overrideHref })=>{
    return /*#__PURE__*/ React.createElement(DeviationShopCard, {
        width: width,
        deviation: deviation,
        overrideHref: overrideHref,
        noCentsOnPrice: true,
        withStats: true,
        withDescriptionBlock: false,
        withAuthorDetails: withAuthorDetails,
        withIndicators: withIndicators,
        belowCoverImageRightSlot: /*#__PURE__*/ React.createElement(AdoptableCardStats, {
            deviation: deviation
        }),
        detailsRightSlot: /*#__PURE__*/ React.createElement(AdoptableDetailsRightSide, {
            deviation: deviation
        })
    });
};
AdoptableShopCard.displayName = 'AdoptableShopCard';
export default AdoptableShopCard;
